<template>
	<div class="main">
		<div class="grzx-left">
			<div class="user-name">
				{{userInfo.name}}
			</div>
			<div class="user-head">
				<img :src="userInfo.headImg ? $imgUrl + userInfo.headImg : '../../../static/user_head.png'" alt="">
			</div>
			<Upload
				class="change-head-button"
				ref="img_ref"
				:action="$baseUrl + '/sys/accessory/uploadFile'"
				:on-success="successUpload"
				:max-size="10240"
				name="uploadFile">
				{{lang == 'zh' ? '修改头像' : 'Change Avatar'}}
			</Upload>
			<div class="user-point">
				{{lang == 'zh' ? '总积分' : 'Total Point'}}：{{userInfo.integral}}
			</div>
			<div class="grzx-box" v-for="(item, index) in leftList" @click="jumpTo(index)" :style="{borderBottom: index == 4 ? '' : '1px solid #C5C5C5', color: index === selectIndex ? '#2D5AC3' : ''}">
				<div>
					<i class="iconfont" :class="item.icon">

					</i>
				</div>
				<div style="margin-left: 10px;">
					{{lang == 'zh' ? item.name : item.en_name}}
				</div>
			</div>
		</div>
		<div class="grzx-right">
			<Row>
				<Col span="6">
					<div class="input-line">
						{{lang == 'zh' ? '昵称' : 'Nick Name'}}：
					</div>
					<div class="input-line">
						{{lang == 'zh' ? '手机号码' : 'Phone Number'}}：
					</div>
					<div class="input-line">
						{{lang == 'zh' ? '身份证号码' : 'Card ID'}}：
					</div>
				</Col>
				<Col span="18">
					<div class="input-right" v-if="editStatus">
						<Input style="width: 240px;" v-model="editObj.nickName"></Input>
						<span style="margin-left: 10px; color: #922627; font-size: 26px;">*</span>
					</div>
					<div class="input-right" v-else>
						{{userInfo.nickName || ''}}
					</div>
					<div class="input-right">
						{{userInfo.mobile || ''}}
					</div>
					<div class="input-right" v-if="editStatus">
						<Input style="width: 240px;" v-model="editObj.idNumber"></Input>
						<span style="margin-left: 10px; color: #922627; font-size: 26px;">*</span>
						<span style="margin-left: 20px; color: #AAAAAA; font-size: 9px;">{{lang == 'zh' ? '为不影响您进馆参观，请您填写真实身份证号。':'In order not to affect your visit, please fill in your real ID number.'}}</span>
					</div>
					<div class="input-right" v-else>
						{{userInfo.idNumber}}
					</div>
					<div style="display: flex;">
						<div class="tcdl" @click="edit" v-if="!editStatus">
							{{lang == 'zh' ? '编辑资料' : 'Edit'}}
						</div>
						<div class="tcdl" @click="editCommit" v-else>
							{{lang == 'zh' ? '提交修改' : 'Commit'}}
						</div>
						<div class="tcdl" @click="logout" style="margin-left: 30px;">
							{{lang == 'zh' ? '退出登录' : 'Logout'}}
						</div>
					</div>

				</Col>
			</Row>
		</div>
	</div>
</template>

<script>
	export default {
		name: '',
		data () {
			return {
				leftList: [
					{
						name: '个人信息',
						en_name: 'Information',
						path: '/grxx',
						icon: 'iconyonghu1'
					},
					{
						name: '我的门票预约',
						en_name: 'Ticket',
						path: '/wdmpyy',
						icon: 'iconmenpiao'
					},
					{
						name: '我的活动预约',
						en_name: 'Activity',
						path: '/wdhdyy',
						icon: 'iconliwu'
					},
					// {
					// 	name: '我的点赞',
					// 	path: '/wddz',
					// 	icon: 'icondianzan'
					// },
					// {
					// 	name: '我的收藏',
					// 	path: '/wdsc',
					// 	icon: 'iconcollection-b'
					// },
				],
				selectIndex: 0,
				userInfo: {

				},
				editStatus: false,
				editObj: {

				},
				imgData: ''
			}
		},
		computed: {
			lang() {
				return this.$store.state.lang
			}
		},
		mounted() {
			let that = this
			that.$store.state.showTopImage = true
			that.$store.state.topImage = '../static/hyzx_top.png'
			that.getUserInfo()
			that.getImgData()
		},
		methods: {
			successUpload(res) {
				let that = this
				if(res.code === 'S200') {
					that.$http.post({
						url: '/api/user/ck/updateUser',
						data: {
							id: that.$http.getStorage('userId'),
							headImg: res.data.id
						}
					}).then(ress => {
						if(ress.code === 'S200') {
							that.getUserInfo()
						} else {
							that.$Message.error(ress.msg)
						}
					})
				}
			},
			getUserInfo() {
				let that = this
				that.$http.post({
					url: '/api/user/ck/getUserDetail',
					data: {
						id: that.$http.getStorage('userId')
					}
				}).then(res => {
					if(res.code === 'S200') {
						if(res.data) {
							that.userInfo = res.data
						} else {
							that.userInfo = {}
						}
					} else if(res.code === 'F001') {
						that.$router.push('login')
					}
				})
			},
			getImgData() {
				let that = this
				that.$http.post({
					url: '/api/user/imageValidateCode',
					data: {}
				}).then(res => {
					if(res.code === 'S200') {
						that.imgData = "data:image/png;base64," + res.data
					} else {
						that.$Message.error(res.msg)
					}
				})
			},
			jumpTo(index) {
				let that = this
				if(index === that.selectIndex) {
					return
				}
				that.$router.push(that.leftList[index].path)
			},
			logout() {
				let that = this
				that.$http.delStorage('token')
				that.$http.delStorage('userId')
				that.$router.push('login')
			},
			edit() {
				let that = this
				that.editObj = {
					id: that.userInfo.id,
					mobile: that.userInfo.mobile,
					idNumber: that.userInfo.idNumber,
					nickName: that.userInfo.nickName
				}
				that.editStatus = true
			},
			editCommit() {
				let that = this
				if(!that.editObj.nickName) {
					that.$Message.error('请输入昵称')
					return
				}
				if(!that.editObj.idNumber) {
					that.$Message.error('请输入身份证号码')
					return
				}
				var data = {
					id: that.editObj.id,
					nickName: that.editObj.nickName,
					idNumber: that.editObj.idNumber
				}
				if(that.userInfo.idNumber == that.editObj.idNumber) {
					delete data.idNumber
				}
				if(that.userInfo.nickName == that.editObj.nickName) {
					delete data.nickName
				}
				that.$http.post({
					url: '/api/user/ck/updateUser',
					data: data
				}).then(res => {
					if(res.code === 'S200') {
						that.editStatus = false
						that.getUserInfo()
					} else {
						that.$Message.error(res.msg)
					}
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.main {
		width: 80%;
		margin: 30px 10% 150px;
		display: flex;
		justify-content: space-between;
		.grzx-left {
			width: 15%;
			padding: 10px 20px;
			background-color: #F6F8FF;
			height: 550px;
			.user-name {
				color: #264EA7;
				font-size: 16px;
				text-align: center;
				overflow: hidden;
				text-overflow: ellipsis;
				height: 30px;
				line-height: 30px;
			}
			.user-head {
				width: 75px;
				height: 75px;
				margin: 10px auto;
				border-radius: 50%;
				img {
					width: 100%;
					height: 100%;
					border-radius: 50%;
				}
			}
			.change-head-button {
				width: 115px;
				height: 25px;
				line-height: 25px;
				margin: 0 auto;
				text-align: center;
				background-color: #264EA7;
				border-radius: 10px;
				color: #FFFFFF;
				font-size: 9px;
				cursor: pointer;
			}
			.user-level {
				width: 70%;
				margin: 10px auto;
				display: flex;
				justify-content: center;
				height: 25px;
				.left {
					border-top: 3px solid #D3D3D3;
					border-bottom: 3px solid #D3D3D3;
					color: #D3D3D3;
					display: flex;
					i {
						font-size: 14px;
					}
				}
				.right {
					background-color: #EDD68E;
					color: #0E40DF;
					font-size: 12px;
					line-height: 25px;
					padding: 0 10px;
				}
			}
			.user-point {
				color: #264EA7;
				font-size: 12px;
				height: 30px;
				line-height: 30px;
			}
			.grzx-box {
				height: 60px;
				line-height: 60px;
				text-align: left;
				display: flex;
				font-size: 13px;
				color: #686868;
				cursor: pointer;
				.iconfont {
					font-size: 16px;
					color: #2D5AC3;
				}
			}
		}
		.grzx-right {
			width: 80%;
			.input-line {
				height: 30px;
				line-height: 30px;
				text-align: right;
				color: #686868;
				font-size: 12px;
				margin-top: 10px;
			}
			.input-right {
				height: 30px;
				line-height: 30px;
				font-size: 12px;
				margin-top: 10px;
				display: flex;
			}
			.tcdl {
				width: 230px;
				height: 35px;
				line-height: 35px;
				text-align: center;
				background-color: #264EA7;
				color: #FFFFFF;
				font-size: 12px;
				cursor: pointer;
				margin-top: 40px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/user_center/grxx.vue